
















































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { ProductAccessory } from '@/api';
import { ProductAccessoryService } from '@/services/product-accessory-service';
import { BvModalEvent } from 'bootstrap-vue';
import Toast from '@/components/display/toast.vue';

@Component({})
export default class EntityAccessories extends Vue {
	public rid = Math.random();

	@Prop({ required: true, type: Number })
	public readonly productId!: number;

	@Prop({ required: false, type: Number })
	public readonly entityId?: number;

	@Prop({ required: false, type: String })
	public readonly entityType?: string;

	@Prop({ required: false, type: Array })
	public readonly accessories?: ProductAccessory[];

	@Prop()
	public localAccessoryFields?: any[];

	@Prop({ required: false, type: Array })
	public readonly accessoriesForInstall?: ProductAccessory[];

	public selectedAccessoryForInstall?: ProductAccessory | null = null;

	public installing: boolean = false;
	public deactivating: boolean = false;

	private productAccessoryService: ProductAccessoryService = new ProductAccessoryService();

	private toast: Toast = new Toast();

	public get accessoryFields() {
		if (!this.localAccessoryFields)
			return [
				{ key: 'serialNumber', label: 'Serial Number', sortable: true },
				{ key: 'accessoryType', label: 'Type', sortable: true },
				{ key: 'deactivate', label: '' },
			];
		return this.localAccessoryFields;
	}

	public get installButtonDisabled(): boolean {
		return !this.accessoriesForInstall || this.accessoriesForInstall.length === 0;
	}

	public async installAccessory(event: BvModalEvent): Promise<void> {
		event.preventDefault();

		if (this.installing) return;

		if (!this.selectedAccessoryForInstall?.id) {
			this.toast.makeToast(
				'No product accessory selected to install',
				'Failed to Install Product Accessory',
				'danger',
			);
			return;
		}

		if (this.entityType === undefined || this.entityId === undefined) {
			this.toast.makeToast(
				'No entity selected to install product accessory on',
				'Failed to Install Product Accessory',
				'danger',
			);
			return;
		}

		this.installing = true;
		const installResult = await this.productAccessoryService.installProductAccessory(
			this.selectedAccessoryForInstall.id,
			this.productId,
			this.entityType,
			this.entityId,
		);
		if (installResult.errorMessage) {
			this.toast.makeToast(
				installResult.errorMessage,
				`Error installing product accessory '${this.selectedAccessoryForInstall.id}'`,
				'danger',
			);
		}
		this.installing = false;
		setTimeout(() => this.$bvModal.hide(event.componentId!), 1);
	}

	public async deactivateAccessory(accessoryId: number): Promise<void> {
		if (this.deactivating) return;

		this.deactivating = true;
		const deactivateResult = await this.productAccessoryService.deactivateProductAccessory(
			accessoryId,
		);
		if (deactivateResult.errorMessage) {
			this.toast.makeToast(
				deactivateResult.errorMessage,
				`Error removing product accessory '${accessoryId}'`,
				'danger',
			);
		}
		this.deactivating = false;
	}
}
